import React, { useEffect, useState } from "react";
import Select from "react-select";

const CarrierCodeSelector = (props) => {

  const handleChange = (selection) => {
    props.setCode(selection)
  };

  const [sortedList, setSortedList] = useState([]);

  const list = [
    { label: "FR", value: "FR" },
    { label: "EI", value: "EI" },
    { label: "TK", value: "TK" },
    { label: "EK", value: "EK" },
    { label: "AF", value: "AF" },
    { label: "BT", value: "BT" },
    { label: "DL", value: "DL" },
    { label: "BA", value: "BA" },
    { label: "OU", value: "OU" },
    { label: "XQ", value: "XQ" },
    { label: "VY", value: "VY" },
    { label: "AA", value: "AA" },
    { label: "LH", value: "LH" },
    { label: "UA", value: "UA" },
    { label: "EY", value: "EY" },
    { label: "LX", value: "LX" },
    { label: "LS", value: "LS" },
    { label: "EZY", value: "EZY" },
    { label: "SI", value: "SI" },
    { label: "KL", value: "KL" },
    { label: "TUI", value: "TUI" },
    { label: "BY", value: "BY" },
    { label: "TOM", value: "TOM" },
    { label: "UL", value: "UL" },
    { label: "AC", value: "AC" },
    { label: "QR", value: "QR" },
    { label: "H4", value: "H4" },
    { label: "RK", value: "RK" },
    { label: "DY", value: "DY" },
    { label: "IB", value: "IB" },
    { label: "AP", value: "AP" },
    { label: "TP", value: "TP" },
    { label: "WS", value: "WS" },
    { label: "VA", value: "VA" },
    { label: "2S", value: "2S" },
    { label: "3L", value: "3L" },
    { label: "5K", value: "5K" },
    { label: "8H", value: "8H" },
    { label: "CL", value: "CL" },
    { label: "E4", value: "E4" },
    { label: "EA", value: "EA" },
    { label: "FI", value: "FI" },
    { label: "LM", value: "LM" },
    { label: "OG", value: "OG" },
    { label: "OR", value: "OR" },
    { label: "R6", value: "R6" },
    { label: "SR", value: "SR" },
    { label: "T3", value: "T3" },
    { label: "T9", value: "T9" },
    { label: "TB", value: "TB" },
    { label: "TS", value: "TS" },
    { label: "V3", value: "V3" },
    { label: "W4", value: "W4" },
    { label: "W6", value: "W6" },
    { label: "WG", value: "WG" },
    { label: "XC", value: "XC" },
    { label: "YW", value: "YW" },
    { label: "5M", value: "5M" },
    { label: "6Y", value: "6Y" },
    { label: "A3", value: "A3" },
    { label: "A5", value: "A5" },
    { label: "AY", value: "AY" },
    { label: "D0", value: "D0" },
    { label: "E6", value: "E6" },
    { label: "E9", value: "E9" },
    { label: "EE", value: "EE" },
    { label: "EW", value: "EW" },
    { label: "FH", value: "FH" },
    { label: "FX", value: "FX" },
    { label: "HU", value: "HU" },
    { label: "HV", value: "HV" },
    { label: "TO", value: "TO" },
    { label: "I2", value: "I2" },
    { label: "JO", value: "JO" },
    { label: "LW", value: "LW" },
    { label: "NO", value: "NO" },
    { label: "RC", value: "RC" },
    { label: "RR", value: "RR" },
    { label: "SK", value: "SK" },
    { label: "SN", value: "SN" },
    { label: "VS", value: "VS" },
    { label: "WK", value: "WK" },
    { label: "WX", value: "WX" },
    { label: "ZQ", value: "ZQ" },
    { label: "SV", value: "SV" },
    { label: "6B", value: "6B" },
    { label: "ASL", value: "ASL" },
    { label: "5F", value: "5F" },
    { label: "B6", value: "B6" },
    { label: "VL", value: "VL" },
    { label: "AM", value: "AM" },
    { label: "AR", value: "AR" },
    { label: "RER", value: "RER" },
    { label: "TX", value: "TX" },
    { label: "Y2", value: "Y2" },
    { label: "UX", value: "UX" },
    { label: "G4", value: "G4" },
    { label: "DM", value: "DM" },
    { label: "XP", value: "XP" },
    { label: "AV", value: "AV" },
    { label: "MX", value: "MX" },
    { label: "DE", value: "DE" },
    { label: "CM", value: "CM" },
    { label: "4Y", value: "4Y" },
    { label: "F9", value: "F9" },
    { label: "GX", value: "GX" },
    { label: "G3", value: "G3" },
    { label: "JA", value: "JA" },
    { label: "LA", value: "LA" },
    { label: "LP", value: "LP" },
    { label: "H2", value: "H2" },
    { label: "DO", value: "DO" },
    { label: "WN", value: "WN" },
    { label: "NK", value: "NK" },
    { label: "SY", value: "SY" },
    { label: "SRD", value: "SRD" },
    { label: "P5", value: "P5" },
    { label: "WL", value: "WL" },
    { label: "2W", value: "2W" },
    { label: "3P", value: "3P" },
    { label: "MS", value: "MS" },
    { label: "DN", value: "DN" },
    { label: "F8", value: "F8" },
    { label: "8C", value: "8C" },
    { label: "5X", value: "5X" },
    { label: "PC", value: "PC" },
    { label: "KK", value: "KK" },
    { label: "WF", value: "WF" },
    { label: "G6", value: "G6" },
    { label: "5R", value: "5R" },
    { label: "6O", value: "6O" },
    { label: "QS", value: "QS" },
    { label: "GR", value: "GR" }
  ];

  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid $props.borderColor",
    }),
  };

  useEffect(() => {
    let tempList = [...list].sort((a, b) => {
      if (a.label < b.label) return -1;
      if (a.label > b.label) return 1;
      return 0;
    });

    setSortedList(tempList);
  }, []);

  // Airline codes are two/three letter IATA designators, not words. Browser
  // translation (Chrome/Google Translate) rewrites bare codes into place names
  // when the page is viewed in another language - "AR" was being rendered as
  // "Arkansas", "NO" as "Norway" etc., which looks like a system fault to the
  // agent. translate="no" + the notranslate class opt this subtree out of
  // translation; formatOptionLabel keeps the guard on the labels themselves so
  // it still holds if the menu is ever rendered through a portal.
  const renderCode = (option) => (
    <span translate="no" className="notranslate">
      {option.label}
    </span>
  );

  return (
    <div translate="no" className="notranslate">
      <Select
        name="Carrier Code"
        options={sortedList}
        className="basic-select"
        classNamePrefix="select"
        formatOptionLabel={renderCode}
        onChange={(selection) => {
          handleChange(selection);
        }}
        styles={customStyles}
        value={{ label: props.carrierCode, value: props.carrierCode }}
      />
    </div>
  );
};

export default CarrierCodeSelector;
